export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
vm(require("ui-addon-upgrades/lang/en.lyaml"));
vm(require("self-service-api/lang/en.lyaml"));
vm(require("ui-addon-i18n/lang/en.lyaml"));
vm(require("./upgradePages/en.lyaml"));
vm(require("./priceDisplay/en.lyaml"));
vm(require("./featureTables/en.lyaml"));
vm(require("pricing-pages-ui-components/lang/en.lyaml"));
at({ "en": { "pricingPagesLib": null } });
};